module.exports = __webpack_public_path__ + "static/img/3.8f0c9bc3.jpg";